import { useEffect, useState } from 'react';

// Hooks
import useLockBodyScroll from './useLockBodyScroll';

const useLightbox = ({
  scrollTo, scrollPrev, scrollNext, prevBtnEnabled, nextBtnEnabled, emblaRef,
}) => {
  const [isOpened, setIsOpened] = useState(false);
  useLockBodyScroll(isOpened);

  useEffect(() => {
    if (!isOpened) setTimeout(() => { scrollTo(0); }, 300);
  }, [isOpened]);

  useEffect(() => {
    const keyHandler = ({ key }) => {
      if (key === 'ArrowLeft' && prevBtnEnabled) scrollPrev();
      if (key === 'ArrowRight' && nextBtnEnabled) scrollNext();
      if (key === 'Escape') setIsOpened(false);
    };

    window.addEventListener('keydown', keyHandler);

    return () => {
      window.removeEventListener('keydown', keyHandler);
    };
  }, [emblaRef, prevBtnEnabled, nextBtnEnabled]);

  return {
    isOpened,
    setIsOpened,
  };
};

export default useLightbox;
